import {trackEvent} from '@/services/tracking.js';
import stepProductMethods from '@/components/workflow/mixins/stepProductMethods';

export default {
	mixins: [stepProductMethods],
	data() {
		return {
			ctas: [
				{
					id: 'share-workflow',
					title: 'Share your Experiment',
					subheader: 'Save and share your experiment with your colleagues and collaborators.',
					handleClick: this.handleShareWorkflowClick,
				},
				{
					id: 'add-products',
					title: 'Buy Products',
					subheader: 'Click here to purchase all products.',
					handleClick: this.addAllProductsToCart,
				},
				{
					id: 'request-genomic',
					title: 'Contact Genomic Services',
					subheader: 'Click here to select the experiment steps you would like us to process.',
					handleClick: this.handleContactGenomicServicesClick,
				},
				{
					id: 'request-quote',
					title: 'Contact Sales',
					subheader: 'Click here to view all products and request a quote.',
					handleClick: this.ctaClick,
				},
			],
		};
	},
	computed: {
		allWorkflowsDisabled() {
			return this.renderWorkFlowSteps.every((workflow) => (!workflow.stepEnabled || !this.isNotEmpty(workflow)));
		},
		workflowsDisabled() {
			return this.renderWorkFlowSteps
				.filter(
					(step) =>
				!this.isCustomWorkStep(step) && !this.isGeneGlobeProduct(step) && !this.isCustomProduct(step) && this.isNotEmpty(step) ,
				)
				.every((workflow) => !workflow.stepEnabled);
		},
		enabledWorkSteps() {
			return this.renderWorkFlowSteps.filter((workflow) => workflow.stepEnabled);
		},
		hasCustomWorkSteps() {
			return this.enabledWorkSteps.some((workflow) => this.isCustomWorkStep(workflow));
		},
		hasCustomProduct() {
			return this.enabledWorkSteps.some((workflow) => this.isCustomProduct(workflow));
		},
		hasGeneGlobe() {
			return this.enabledWorkSteps
				.filter((workflow) => !this.isCustomWorkStep(workflow))
				.some((workflow) => this.isGeneGlobeProduct(workflow));
		},
		hasCustomStepCustomProduct() {
			const filteredCustom = this.enabledWorkSteps.filter(
				(workflow) => this.isCustomProduct(workflow) || this.isCustomWorkStep(workflow),
			);
			return (
				filteredCustom.length >= 2 && (this.hasCustomWorkSteps || this.hasCustomProduct || this.hasGeneGlobe)
			);
		},
	},
	methods: {
		getSnackbarDetails(number) {
			const getExcludedList = () => {
				const list = [];
				if (this.hasGeneGlobe) list.push('Gene Globes');
				if (this.hasCustomProduct) list.push('custom products');
				if (this.hasCustomWorkSteps) list.push('custom steps');
				return list.join(', ');
			};
			const getTitle = {
				1: 'At least one step should be enabled.',
				2: `At least one step, excluding ${getExcludedList()}, should be enabled.`,
			};
			this.$store.commit('setSalesGenomicSnackbarActive', true);
			this.$root.$emit('showGlobalBanner', {
				title: getTitle[number],
				body: '',
				version: 'warning',
				btn: 'dismiss',
				btnEmits: 'closeGlobalBanner',
			});
		},
		checkDisabledStatus() {
			if (this.allWorkflowsDisabled ) {
				this.getSnackbarDetails(1);
			} else if (
				this.hasCustomStepCustomProduct ||
				this.hasCustomProduct ||
				this.hasCustomWorkSteps ||
				this.hasGeneGlobe
			) {
				this.getSnackbarDetails(2);
			}
		},
		ctaClick(id) {
			if (id === 'request-quote') {
				trackEvent('ctaClick', {eVar58: 'Contact sales rep| Workflow Configurator'});
			}

			if (!this.workflowsDisabled) {
				if (this.checkIfLoggedIn() && !this.isJwtExpired()) {
					this.$root.$emit('unsetGenomic');
					this.showRequestsModal = true;
				} else {
					this.resetJwtCookie();
					this.requestQuoteSelected = id === 'request-quote';
					this.preLoginModal = true;
					this.$root.$emit('unsetGenomic');
				}
			} else {
				this.checkDisabledStatus();
			}
		},
		handleContactGenomicServicesClick(id) {
			trackEvent('ctaClick', {eVar58: 'Contact Genomic Services| Workflow Configurator'});
			if (!this.workflowsDisabled) {
				if (this.checkIfLoggedIn() && !this.isJwtExpired()) {
					this.showRequestsModal = true;
					this.isGenomic = true;
					localStorage.removeItem('isGenomic');
				} else {
					this.resetJwtCookie();
					this.requestGenomicSelected = id === 'request-genomic';
					this.preLoginModal = true;
					localStorage.setItem('isGenomic', true);
				}
			} else {
				this.checkDisabledStatus();
			}
		},
		toggleBodyScroll() {
			const body = document.body;
			body.style.overflow = this.showRequestsModal ? 'hidden' : '';
		},
		handleShareWorkflowClick() {
			trackEvent('ctaClick', {eVar58: 'Share workflow| Workflow Configurator'});
			this.openShareWorkflowModal();
		},
	},
};
